module.exports = __webpack_public_path__ + "img/trip.fc462989.jpg";